import { FormattedMessage } from 'react-intl';

const InvalidDateRange = (): JSX.Element => {
  return (
    <FormattedMessage
      id="account_v2.homepage.filter_trips.form_error.invalid_range"
      defaultMessage="Date to must be larger than date from"
    />
  );
};

export default InvalidDateRange;
